import { Grid, Box, ButtonGroup, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { StyledLink } from 'components/styles_components/link';
import { WhiteCard } from 'components/styles_components/card';
import { PlaceLink } from 'utils/link';
import { CardOptionTypography, CardTitleTypography, CardOptionHintTypography } from 'components/styles_components/typography';
import ShowItemTableRow from 'components/item/show_item_table_row';
import InspectionSubject from 'utils/inspection_subject';
import EditButton from 'components/inspection_subject/button/edit';
import DeleteButton from 'components/inspection_subject/button/delete';
import ComplianceStats from 'components/compliance_stats/container';

const ShowItem = ({ inspectionSubject, space, refetch }) => {
  return (
    <Grid container spacing={2}>
      <Grid item size={{ xs: 12 }}>
        <Grid item size={{ xs: 12 }}>
          <WhiteCard
            className={InspectionSubject(inspectionSubject).htmlClass}
            style={{ height: '100%', margin: 0, boxSizing: 'border-box', width: '100%' }}
          >
            <CardTitleTypography variant="h5">{inspectionSubject.name}</CardTitleTypography>
            <ComplianceStats
              complianceRatio={inspectionSubject.complianceRatio}
              overdueInspectionsTotal={inspectionSubject.overdueInspectionsTotal}
              incomingInspectionsTotal={inspectionSubject.incomingInspectionsTotal}
              pendingInspectionsTotal={inspectionSubject.pendingInspectionsTotal}
            />
            <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
              <Grid item size={{ xs: 12 }}>
                <Table>
                  <TableBody>
                    <ShowItemTableRow label={<FormattedMessage id="inspection_subject.brand" />}>
                      {inspectionSubject.brand || '-'}
                    </ShowItemTableRow>
                    <ShowItemTableRow label={<FormattedMessage id="inspection_subject.model" />}>
                      {inspectionSubject.model || '-'}
                    </ShowItemTableRow>
                    <ShowItemTableRow
                      label={<FormattedMessage id="inspection_subject.serial_number" />}
                    >
                      {inspectionSubject.serialNumber || '-'}
                    </ShowItemTableRow>
                  </TableBody>
                </Table>
              </Grid>
              {inspectionSubject.notes && (
                <Grid item size={{ xs: 12 }}>
                  <CardOptionTypography>
                    <FormattedMessage id="inspection_subject.notes" />
                  </CardOptionTypography>
                  <CardOptionHintTypography sx={{ m: 1 }}>{inspectionSubject.notes}</CardOptionHintTypography>
                </Grid>
             )}
            </Grid>
            {space.adminRole && (
              <ButtonGroup>
                <EditButton inspectionSubject={inspectionSubject} space={space} refetch={refetch} />
                <DeleteButton inspectionSubject={inspectionSubject} space={space} />
              </ButtonGroup>
            )}
          </WhiteCard>
        </Grid>
        <Grid item size={{ xs: 12 }} sx={{ mt: 2 }}>
          <WhiteCard>
            <CardOptionTypography>
              <FormattedMessage id="place" />
            </CardOptionTypography>
            <Table>
              <TableBody>
                <ShowItemTableRow label={<FormattedMessage id="place.name" />}>
                  {inspectionSubject.place.name}
                </ShowItemTableRow>
                <ShowItemTableRow label={<FormattedMessage id="place.street" />}>
                  {inspectionSubject.place.street}
                </ShowItemTableRow>
                <ShowItemTableRow label={<FormattedMessage id="place.city" />}>
                  {inspectionSubject.place.city}
                </ShowItemTableRow>
              </TableBody>
            </Table>
            <Box display="flex" justifyContent="flex-end">
              <StyledLink to={PlaceLink(inspectionSubject.place.id)}>
                <FormattedMessage id="button.place.view" />
              </StyledLink>
            </Box>
          </WhiteCard>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShowItem;
